import _ from 'underscore';
import BaseView from './components/baseView.js';

var ENTER = 13;
export default class Content extends BaseView {
  /**
   * @todo remove redundancy
   */
  constructor(options) {
    super(options);
    this._commonEvents();
  }

  beforeFilter() {
    // Does nothing, should be overriden
  }

  destroy() {
    this._destroy();
  }

  _ensureDefaultElement() {
    if (typeof this.el !== 'undefined') {
      return;
    }
    this._setElement('#main-content');
  }

  _destroy() {
    if (_.isFunction(this.onDestroy)) {
      this.onDestroy();
    }
    this.remove();
  }

  error() {
    this.$el = $(this.el);
    this.render();
  }

  _render() {
    this.render();
  }

  checkRadioButtons() {
    var $radioFields = this.$('td.radio'),
      $el;

    $.each($radioFields, function (index, el) {
      $el = $(el);
      if ($el.parents('.disabled-form').length !== 0) {
        return;
      }
      if ($el.find('input:checked').length === 0) {
        $el.closest('td.radio').find('.unselect').hide();
      }
    });
  }

  /**
   * @todo remove redundancy
   */
  _commonEvents() {
    this.__commonEvents();
  }

  __commonEvents() {
    if (typeof this.sendOnEnter === 'undefined' || this.sendOnEnter === true) {
      this.$el.on(
        'keydown',
        'form input[type=text]',
        $.proxy(this._keydownForm, this),
      );
    }
    this.$el.on('click', '.unselect', $.proxy(this._hideUnselect, this));
    this.$el.on(
      'click',
      'form .radio label',
      $.proxy(this._showUnselect, this),
    );
    this.$el.on(
      'click',
      '.io-form-action-edit',
      $.proxy(this.checkRadioButtons, this),
    );
  }

  _hideUnselect(e) {
    var $unselect = $(e.currentTarget),
      $radio;

    $radio = $unselect
      .parent()
      .find('input[type=radio]')
      .prop('checked', false);
    $unselect.parent().find('.custom.radio').removeClass('checked');
    $('<input type="hidden" name="' + $radio.prop('name') + '" />').insertAfter(
      $unselect,
    );
    $unselect.hide();
  }

  _showUnselect(e) {
    var $unselect;

    if ($(e.currentTarget).find('[disabled=disabled]').length > 0) {
      return;
    }

    $unselect = $(e.currentTarget).parent().find('.unselect');
    $unselect.next().remove();
    $unselect.show();
  }

  _keydownForm(e) {
    this.__keydownForm(e);
  }

  __keydownForm(e) {
    if (e.keyCode === ENTER) {
      e.preventDefault();
      e.stopPropagation();
      $(e.target).parents('form').submit();
    }
  }
}
